/**
 * 对话框相关服务
 * Bai.Zhiming
 * 2019-7-22
 */
angular.module('dialogBoxServiceModule', []).
factory('dialogBoxService', ['$q', 'modalDialog', function($q, modalDialog) {
    return {
        /**
         * [sendImage description] 发送图片
         * @param  {[type]} image               [description] 上传成功的图片信息
         * @param  {[type]} selType             [description] 聊天类型
         * @param  {[type]} selToID             [description] 聊天对象id
         * @param  {[type]} friendHeadUrl       [description] 好友头像
         * @param  {[type]} loginIdentifier     [description] 本人登录名称
         * @param  {[type]} loginIdentifierNick [description] 本人昵称
         * @return {[type]}                     [description]
         */
        sendImage(image, selType, selToID, friendHeadUrl, loginIdentifier, loginIdentifierNick) {
            let deffer = $q.defer();
            let selSess = new webim.Session(selType, selToID, selToID, friendHeadUrl, Math.round(new Date().getTime() / 1000));
            let msg = new webim.Msg(selSess, true, -1, -1, -1, loginIdentifier, 0, loginIdentifierNick);
            let images_obj = new webim.Msg.Elem.Images(image.File_UUID, image.name.split(".")[1]);
            for (let i in image.URL_INFO) {
                var img = image.URL_INFO[i];
                var newImg;
                var type;
                switch (img.PIC_TYPE) {
                    case 1: //原图
                        type = 1; //原图
                        break;
                    case 2: //小图（缩略图）
                        type = 3; //小图
                        break;
                    case 4: //大图
                        type = 2; //大图
                        break;
                }
                newImg = new webim.Msg.Elem.Images.Image(type, img.PIC_Size, img.PIC_Width, img.PIC_Height, img.DownUrl);
                images_obj.addImage(newImg);
            }
            msg.addImage(images_obj);
            webim.sendMsg(msg, function(resp) {
                deffer.resolve(msg);
            }, function(err) {
                console.log(err.ErrorInfo);
                deffer.reject();
            });
            return deffer.promise;
        },
        /**
         * [sendImage description] 批量发送图片
         * @param  {[type]} images               [description] 上传成功的图片集合信息
         * @param  {[type]} selType             [description] 聊天类型
         * @param  {[type]} selToID             [description] 聊天对象id
         * @param  {[type]} friendHeadUrl       [description] 好友头像
         * @param  {[type]} loginIdentifier     [description] 本人登录名称
         * @param  {[type]} loginIdentifierNick [description] 本人昵称
         * @return {[type]}                     [description]
         */
        sendImages(images, selType, selToID, friendHeadUrl, loginIdentifier, loginIdentifierNick) {
            let deffer = $q.defer();
            let promiseArray = [];
            for (let i = 0; i < images.length; i++) {
                let image = images[i];
                promiseArray.push(this.sendImage(image, selType, selToID, friendHeadUrl, loginIdentifier, loginIdentifierNick));
            }
            $q.all(promiseArray).then(resp => {
                deffer.resolve(resp);
            }, error => {
                console.log(error);
            });
            return deffer.promise;
        },
        /**
         * [uploadImage description] 上传图片
         * @param  {[type]} file         [description] 被上传的文件
         * @param  {[type]} account      [description] 上传人账号
         * @param  {[type]} businessType [description] 上传类型
         * @return {[type]}              [description]
         */
        uploadImage(file, account, businessType) {
            let deffer = $q.defer();
            webim.uploadPic({
                file: file,
                /**
                 * [onProgressCallBack description] 上传进度回调
                 * @param  {[type]} e [description] 进度数据
                 * @return {[type]}   [description]
                 */
                onProgressCallBack(e) {

                },
                To_Account: account,
                businessType: Number(businessType)
            }, resp => {
                deffer.resolve(resp);
            }, error => {
                console.log('发送图片失败');
                deffer.reject(error);
            })
            return deffer.promise;
        },
        /**
         * [uploadImages description] 多图上传
         * @param  {[type]} files        [description] 上传图片集合
         * @param  {[type]} account      [description] 上传人账号
         * @param  {[type]} businessType [description] 上传类型
         * @return {[type]}              [description]
         */
        uploadImages(files, account, businessType) {
            let deffer = $q.defer();
            let self = this;
            let promiseArray = [];
            let overSizeArray = [];
            let formErrorArray = [];
            for (let i = 0; i < files.length; i++) {
                let file = files[i];
                let size = file.size / (Math.pow(1024, 2));
                let fileType = file.name.split(".")[1].toLowerCase();
                if (size >= 20) {
                    overSizeArray.push(file);
                    continue;
                }
                if (".jpg,.png,.gif,.bmp,.jpeg".indexOf(fileType) < 0) {
                    formErrorArray.push(file);
                    continue;
                }
                file.index = i;
                promiseArray.push(uploadImage(file));
            }
            if (overSizeArray.length > 0) {
                let reports = {
                    TITLE: '发现图片文件超过20M',
                    ISSUCCESS: 'false',
                    REPORTS: []
                };
                overSizeArray.forEach(item => {
                    reports.REPORTS.push({
                        TITLE: `图片${item.name}的大小超过了20M,无法上传`,
                        ISSUCCESS: 'false'
                    });
                });
                modalDialog.multiReportsAlert(reports);
            }
            if (formErrorArray.length > 0) {
                let reports = {
                    TITLE: '发现文件类型错误',
                    ISSUCCESS: 'false',
                    REPORTS: []
                };
                formErrorArray.forEach(item => {
                    reports.REPORTS.push({
                        TITLE: `文件${item.name}不是图片类型`,
                        ISSUCCESS: 'false'
                    });
                });
                modalDialog.multiReportsAlert(reports);
            }
            if (promiseArray.length == 0) {
                deffer.resolve([]);
                return deffer.promise;
            }
            $q.all(promiseArray).then(resp => {
                if (!angular.isArray(resp) || resp.length == 0){
                    deffer.resolve([]);
                }
                resp = resp.sort((x, y) => {
                    return x.index - y.index;
                });
                deffer.resolve(resp);
            }, error => {
                deffer.reject();
            });
            return deffer.promise;
            /**
             * [uploadImage description] 上传私有方法图片
             * @param  {[type]} file [description] 图片文件
             * @return {[type]}      [description]
             */
            function uploadImage(file) {
                let deffer_ = $q.defer();
                self.uploadImage(file, account, businessType).then(resp => {
                    resp.index = file.index;
                    resp.name = file.name;
                    deffer_.resolve(resp);
                }, err => {
                    deffer_.reject(err);
                });
                return deffer_.promise;
            }
        }
    };
}]);